import { AxiosResponse } from "axios";
import IHttpPutServiceProps from "./IHttpPutServiceProps";
import { instance } from 'Services/instance'
import { ToastUpdateSuccessBottomLeft } from "Utils/toastService";
import i18n from "i18next";

const { t } = i18n

const HttpPutService = async (props: IHttpPutServiceProps) => {
  if (props.onResult === undefined) {
    props.onResult = (res: AxiosResponse<any, any>): any => {
      if (res.status === 201) {
        ToastUpdateSuccessBottomLeft(t("VISIT"))
        return res.data;
      }
    };
  }
  if (props.onError === undefined) {
    props.onError = (error: any) => {
      console.error(error);
    };
  }

  try {
    const response = await instance.put(props.url, props.body)
      .then(props.onResult)
      .catch(props.onError);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export default HttpPutService;
